import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from '../../../util/reactIntl';
import { Button, Modal } from '../../../components';

import css from './StoreSearchScopeModal.module.css';

const MODAL_ID = 'StoreSearchScopeModal';

/**
 * "This search leaves [store]" confirmation (RAS-2619).
 *
 * Shown every time a shopper on a store page reaches for the topbar's marketplace-wide
 * search. Bottom sheet on phones, compact centered dialog from tablet up; sized to its
 * content so it never scrolls. Every dismissal (X, backdrop, Esc, Cancel) is a plain
 * close - only the two named buttons do anything else.
 */
const StoreSearchScopeModal = props => {
  const {
    isOpen,
    storeName,
    onClose,
    onStayOnStore,
    onSearchMarketplace,
    onManageDisableScrolling,
  } = props;

  const titleId = `${MODAL_ID}-title`;
  const descriptionId = `${MODAL_ID}-description`;

  return (
    <Modal
      id={MODAL_ID}
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      scrollLayerClassName={css.scrollLayer}
      containerClassName={css.container}
      contentClassName={css.content}
      closeButtonClassName={css.closeButton}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
        className={css.dialog}
      >
        <div className={css.dragHandleArea} aria-hidden="true">
          <span className={css.dragHandle} />
        </div>
        <h2 id={titleId} className={css.title}>
          <FormattedMessage id="StoreSearchScopeModal.title" values={{ storeName }} />
        </h2>
        <p id={descriptionId} className={css.description}>
          <FormattedMessage id="StoreSearchScopeModal.description" />
        </p>
        <div className={css.actions}>
          <Button
            type="button"
            variant="primary"
            className={css.actionButton}
            onClick={onStayOnStore}
          >
            <FormattedMessage id="StoreSearchScopeModal.stayOnStore" values={{ storeName }} />
          </Button>
          <Button
            type="button"
            variant="secondary-outline"
            className={css.actionButton}
            enforcePagePreloadFor="SearchPage"
            onClick={onSearchMarketplace}
          >
            <FormattedMessage id="StoreSearchScopeModal.searchMarketplace" />
          </Button>
        </div>
        <button type="button" className={css.cancelLink} onClick={onClose}>
          <FormattedMessage id="StoreSearchScopeModal.cancel" />
        </button>
      </div>
    </Modal>
  );
};

StoreSearchScopeModal.defaultProps = {
  storeName: '',
};

StoreSearchScopeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onStayOnStore: PropTypes.func.isRequired,
  onSearchMarketplace: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
};

export default StoreSearchScopeModal;
